import { useState } from 'react';
import { Button, CircularProgress, TextField, Box, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { SignOutUser, createUser } from '../../utils/firebase/firebase.utils';
//import { useForm } from 'react-hook-form';

const defaultSignUpFormFields = {
  displayName: '',
  email: '',
  password: '',
  advertiserId: '',
}

const SignUp = () => {
  const [formFields, setFormFields] = useState(defaultSignUpFormFields)
  const { displayName, email, password, advertiserId } = formFields
  const [loading, setLoading] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [errors, setErrors] = useState<{ [key: string]: boolean }>({})

  const resetFormFields = () => {
    setFormFields(defaultSignUpFormFields)
    setErrors({})
  }

  const handleChange = (event: any) => {
    const { name, value } = event.target
    setFormFields({ ...formFields, [name]: value })
    setErrors({ ...errors, [name]: false })
  }

  const handleSubmit = async (event: any) => {
    event.preventDefault()
    const newErrors: { [key: string]: boolean } = {}
    if (!displayName) newErrors.displayName = true
    if (!email) newErrors.email = true
    if (!password) newErrors.password = true
    if (!advertiserId) newErrors.advertiserId = true

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
      return
    }

    setLoading(true)
    try {
      const response = await createUser({ email, password, displayName, advertiserId })
      if (!response.success) {
        alert(response.error)
      }
      if (response.user) {
        setOpenDialog(true)
      }
      resetFormFields()
    } catch (err: any) {
      if (err.code === 'auth/email-already-in-use') {
        alert('User email already in use')
      }
      console.log('user creation error: ', err)
    }
    setLoading(false)
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
    SignOutUser()
  }

  return (
    <Box sx={{
      padding: '6rem 0 3rem',
    }}>
      <h1>Sign-Up user for LGSS</h1>
      <Box
        component="form"
        sx={{
          padding: '1rem',
          '& .MuiTextField-root': { mb: 3, width: '100%', maxWidth: '420px' },
        }}
        noValidate
        autoComplete="off"
        onSubmit={handleSubmit}
      >
        <div>
          <TextField
            required
            id="displayName"
            name="displayName"
            label="Name"
            type="text"
            autoComplete="name"
            onChange={handleChange}
            value={displayName}
            error={!!errors.displayName}
            helperText={errors.displayName ? 'Name is required' : ''}
          />
        </div>
        <div>
          <TextField
            required
            id="email"
            name="email"
            label="Email"
            type="email"
            autoComplete="email"
            onChange={handleChange}
            value={email}
            error={!!errors.email}
            helperText={errors.email ? 'Email is required' : ''}
          />
        </div>
        <div>
          <TextField
            required
            id="password"
            label="Password"
            type="password"
            name="password"
            autoComplete="new-password"
            onChange={handleChange}
            value={password}
            error={!!errors.password}
            helperText={errors.password ? 'Password is required' : ''}
          />
        </div>
        <div>
          <TextField
            required
            id="advertiserId"
            label="LeadsPedia Advetrtiser Id"
            name="advertiserId"
            type="text"
            onChange={handleChange}
            value={advertiserId}
            error={!!errors.advertiserId}
            helperText={errors.advertiserId ? 'Advertiser Id is required' : ''}
          />
        </div>
        <br />
        <div>
          {loading ?
            <CircularProgress />
            :
            <Button
              type="submit"
              size='large'
              variant='contained'
            >
              Submit
            </Button>
          }
        </div>
      </Box>
      <Dialog
        open={openDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"User Created Successfully!"}
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleCloseDialog}>OK</Button>
        </DialogActions>
      </Dialog>
    </Box >
  );
}

export default SignUp